import type { Language } from '@brainkey/shared';

/** The 3 languages a client can set as their `languagePref` — shared between
 * `EditProfilePage`'s onboarding-edit wizard and the topbar `LanguageToggle`
 * so both list the same options with the same native-script labels. */
export const LANGUAGE_OPTIONS: { value: Language; native: string }[] = [
  { value: 'EN', native: 'English' },
  { value: 'SI', native: 'සිංහල' },
  { value: 'TA', native: 'தமிழ்' },
];
